import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 


const firebaseConfig = {
  apiKey: "AIzaSyDdn00Je6ZYFzdi3cs5NVFKB3hdqXXrO8Q",
  authDomain: "tesbihcimen-c37c4.firebaseapp.com",
  projectId: "tesbihcimen-c37c4",
  storageBucket: "tesbihcimen-c37c4.firebasestorage.app",
  messagingSenderId: "1013876524655",
  appId: "1:1013876524655:web:8fcd96df295cf3697a6f9a",
  measurementId: "G-PPT27ZCJ5N"
};


const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); 